/*
 * @Author: 王一宁 wangyining@fenxiangbuy.com
 * @Date: 2024-08-06 14:23:42
 * @LastEditors: 王一宁 wangyining@fenxiangbuy.com
 * @LastEditTime: 2024-08-28 11:26:29
 * @FilePath: /shengsheng-client/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/SmileOrderIntro.vue"),
    meta: {
      title: "杭州玩赚省数字科技有限公司",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
    meta: {
      title: "爱省生活注册",
    },
  },
  {
    path: "/taobaoAuth",
    name: "taobaoAuth",
    component: () => import("../views/TaobaoAuth.vue"),
    meta: {
      title: "淘宝授权",
    },
  },
  {
    path: "/aggrement/privacy",
    name: "Privacy",
    component: () => import("../views/aggrement/privacy.vue"),
    meta: {
      title: "隐私协议",
    },
  },
  {
    path: "/aggrement/mike-privacy",
    name: "MikePrivacy",
    component: () => import("../views/aggrement/mike-privacy.vue"),
    meta: {
      title: "Mike情报隐私协议",
    },
  },
  {
    path: "/aggrement/smile-privacy",
    name: "SmilePrivacy",
    component: () => import("../views/aggrement/smile-privacy.vue"),
    meta: {
      title: "微笑团情报隐私协议",
    },
  },
  {
    path: "/aggrement/user",
    name: "User",
    component: () => import("../views/aggrement/user.vue"),
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/aggrement/behavior",
    name: "Behavior",
    component: () => import("../views/aggrement/behavior.vue"),
    meta: {
      title: "行为规范",
    },
  },
  {
    path: "/cash/read",
    name: "CashRead",
    component: () => import("../views/cash/read.vue"),
    meta: {
      title: "提现须知",
    },
  },
  {
    path: "/user/question",
    name: "Question",
    component: () => import("../views/user/question.vue"),
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/user/new-read",
    name: "NewRead",
    component: () => import("../views/user/new-read.vue"),
    meta: {
      title: "新手必看",
    },
  },
  {
    path: "/user/share-reward",
    name: "ShareReward",
    component: () => import("../views/user/share-reward.vue"),
    meta: {
      title: "奖励规则",
    },
  },
  {
    path: "/company/company-qualification",
    name: "CompanyQualification",
    component: () => import("../views/company/company-qualification.vue"),
    meta: {
      title: "公司资质",
    },
  },
  {
    path: "/download-guide",
    name: "DownloadGuide",
    component: () => import("../views/DownloadGuide.vue"),
    meta: {
      title: "下载爱省生活",
    },
  },
  {
    path: "/smile/sunflower-business",
    name: "SmileSunflowerBusiness",
    component: () =>
      import("../views/smile-order/sunflower-business/index.vue"),
    meta: {
      title: "太阳花商学院",
    },
  },
  {
    path: "/smile-order/",
    name: "SmileOrderIndex",
    redirect: "/smile-order/actives",
    meta: {
      title: "报单中心",
    },
    children: [
      {
        path: "/smile-order/login",
        name: "SmileOrderLoginIndex",
        component: () => import("../views/smile-order/login.vue"),
        meta: {
          title: "手机号验证码登录",
        },
      },
      {
        path: "/smile-order/actives",
        name: "SmileOrderActivesIndex",
        component: () => import("../views/smile-order/actives/index.vue"),
        meta: {
          title: "会员",
        },
      },
      {
        path: "/smile-order/report/:userId?/:groupId?",
        name: "SmileOrderReportIndex",
        component: () => import("../views/smile-order/actives/index.vue"),
        meta: {
          title: "报单中心",
        },
      },
      {
        path: "/smile-order/orders",
        name: "SmileOrderOrdersIndex",
        component: () => import("../views/smile-order/orders/index.vue"),
        meta: {
          title: "报单订单",
        },
      },
      {
        path: "/smile-order/profile",
        name: "SmileOrderProfileIndex",
        component: () => import("../views/smile-order/profile/index.vue"),
        meta: {
          title: "个人中心",
        },
      },
    ],
  },
  {
    path: "/mike-order",
    name: "MikeOrder",
    component: () => import("../views/mike-order/index.vue"),
    meta: {
      title: "订单查询",
    },
  },
  {
    path: "/smile/article",
    name: "SmileArticleIndex",
    component: () => import("../views/smile/article/index.vue"),
    meta: {
      title: "  ",
    },
  },
  {
    path: "/smile/income",
    name: "SmileIncomeIndex",
    component: () => import("../views/smile/income/index.vue"),
    meta: {
      title: "收益明细",
    },
  },
  {
    path: "/smile/venue",
    name: "SmileVenueIndex",
    component: () => import("../views/smile/venue/index.vue"),
    meta: {
      title: "抖音会场",
    },
  },
  {
    path: "/smile/settlement",
    name: "SmileSettlementIndex",
    component: () => import("../views/smile/settlement/index.vue"),
    meta: {
      title: "结算明细",
    },
  },
  {
    path: "/smile/report-settlement",
    name: "SmileReportSettlementIndex",
    component: () => import("../views/smile/report-settlement/index.vue"),
    meta: {
      title: "报单结算",
    },
  },
  {
    path: "/smile/link-settlement",
    name: "SmileLinkSettlementIndex",
    component: () => import("../views/smile/link-settlement/index.vue"),
    meta: {
      title: "转链结算",
    },
  },
  {
    path: "/smile/link-order",
    name: "SmileLinkOrderIndex",
    component: () => import("../views/smile/link-order/index.vue"),
    meta: {
      title: "转链订单",
    },
  },
  {
    path: "/smile/paishou",
    name: "SmilePaishouIndex",
    component: () => import("../views/smile/paishou/index.vue"),
    meta: {
      title: "拍手中心",
    },
  },
  {
    path: "/smile/paishou/orders",
    name: "SmilePaishouOrders",
    component: () => import("../views/smile/paishou/orders.vue"),
    meta: {
      title: "拍手订单",
    },
  },
  {
    path: "/smile/paishou/settle",
    name: "SmilePaishouSettle",
    component: () => import("../views/smile/paishou/settle.vue"),
    meta: {
      title: "拍手汇总",
    },
  },
  {
    path: "/smile/paishou/transfer",
    name: "SmilePaishouTransfer",
    component: () => import("../views/smile/paishou/transfer.vue"),
    meta: {
      title: "拍手转链",
    },
  },
  {
    path: "/smile/history-settlement",
    name: "SmileHistorySettlementIndex",
    component: () => import("../views/smile/history-settlement/index.vue"),
    meta: {
      title: "历史结算",
    },
  },
  {
    path: "/smile/sub-commission-rate",
    name: "SmileSubCommissionRateIndex",
    component: () => import("../views/smile/sub-commission-rate/index.vue"),
    meta: {
      title: "下级分佣比例",
    },
  },
  {
    path: "/smile/third-order",
    name: "SmileThirdOrderIndex",
    component: () => import("../views/smile/third-order/index.vue"),
    meta: {
      title: "报单订单",
    },
  },
  {
    path: "/smile/group",
    name: "SmileGroupIndex",
    component: () => import("../views/smile/group/index.vue"),
    meta: {
      title: "团队详情",
    },
  },
  {
    path: "/smile/group/user-info",
    name: "SmileGroupUserInfo",
    component: () => import("../views/smile/group/user-info.vue"),
    meta: {
      title: "用户信息",
    },
  },
  {
    path: "/smile/group/level-up",
    name: "SmileGroupLevelUp",
    component: () => import("../views/smile/group/level-up.vue"),
    meta: {
      title: "等级升级",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const sessionIdFromQuery =
    typeof to.query.smileOrderSessionId === "string"
      ? to.query.smileOrderSessionId.trim()
      : "";

  // 只要地址栏携带 smileOrderSessionId，就优先覆盖本地登录态
  if (sessionIdFromQuery) {
    localStorage.setItem("smileOrderSessionId", sessionIdFromQuery);
  }

  const requiresSmileOrderLogin =
    to.path.startsWith("/smile-order") ||
    to.path === "/smile/income" ||
    to.path.startsWith("/smile/settlement") ||
    to.path === "/smile/report-settlement" ||
    to.path === "/smile/link-settlement" ||
    to.path.startsWith("/smile/paishou") ||
    to.path === "/smile/history-settlement" ||
    to.path === "/smile/sub-commission-rate";

  // 报单中心及收益页登录态校验
  if (requiresSmileOrderLogin) {
    // 排除登录页面和根路径
    if (
      to.path === "/smile-order/login" ||
      to.path === "/smile-order" ||
      to.path === "/smile-order/"
    ) {
      next();
      return;
    }

    if (sessionIdFromQuery) {
      next();
      return;
    }

    // 检查是否有登录态（sessionId）
    const sessionId = localStorage.getItem("smileOrderSessionId");
    if (!sessionId) {
      // 未登录，跳转到登录页面
      next({
        path: "/smile-order/login",
        query: { redirect: to.fullPath }, // 保存原始路径，登录后可以跳转回来
      });
      return;
    }
  }

  next();
});

// 仅在导航确认完成后更新标题，避免登录重定向或快速切换页面时，
// Android WebView 捕获到中间路由的标题。
router.afterEach((to, from, failure) => {
  if (failure) {
    return;
  }

  const isSmileMikeRoot =
    typeof window !== "undefined" &&
    window.location.hostname === "www.smilemike.cn" &&
    to.path === "/";

  document.title = isSmileMikeRoot
    ? "杭州玩赚省数字科技有限公司"
    : to.meta.title || "爱省生活";
});

export default router;
